<div
  #tnetModalToggle
  [class]="{ 'modal-show': tnetModalShow }"
  class="tnet-companies-container flex-wrap"
>
  <div *ngIf="tnetModalShow" class="transparent-bg"></div>
  <div class="b-flex d-xl-none position-relative w-100">
    <div (click)="closeTnetModal(false)" class="close cursor-pointer">
      <img src="/assets/images/close.svg" alt="X" />
    </div>
  </div>
  <div
    class="tnet-companies-container__content position-relative d-flex flex-wrap h-100 bg-white"
  >
    <div class="tnet-companies-container__header w-100">
      <h6 class="f-family-bold f-size-18 text-black mb-2">TNET</h6>
      <p class="f-family-regular f-size-12 f-color-slate p-0 m-0">
        ყველაზე დიდი ტექნოლოგიური ეკოსისტემა, რომელიც აერთიანებს 10 პლატფორმას:
      </p>
    </div>
    <div
      class="tnet-companies-container__content d-flex flex-wrap overflow-auto w-100"
      custom-scrollbar
    >
      <div
        *ngFor="let item of TNetCompaniesList"
        :key="i"
        [class]="{ active: item.name === 'livo' }"
        class="tnet-companies__item d-flex justify-content-center align-items-center cursor-pointer"
      >
        <a
          [href]="item.url"
          target="_blank"
          class="w-100 h-100 d-flex justify-content-center align-items-center"
        >
          <img
            [src]="'/assets/images/tnetCompanies/' + item.logo"
            [alt]="item.name"
            [class]="{ 'height-21': item.name === 'myMarket' }"
          />
        </a>
      </div>
    </div>
  </div>
</div>
